import React from 'react';
import { useLocation } from 'react-router-dom';
import TitleBreadCrumbs from '../../../components/common/breadcrumbs/TitleBreadCrumbs';

const TitleBreadCrumbsContainer = ({title}) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  const titlenames = title.split('/').filter((x) => x);

  return <TitleBreadCrumbs pathnames={pathnames} titlenames={titlenames}/>;
};

export default TitleBreadCrumbsContainer;

